import React, { Component, useContext } from 'react';
import { MyHeading, MyGlobal, MyAlert } from '../components/GlobalContext';
import LinkButton from '../components/LinkButton';
import * as $ from 'jquery';
import * as MySound from '../components/MySound';
import Modal from 'react-bootstrap/Modal';
import ConfirmLocationChargeSkeleton from '../components/ConfirmLocationChargeSkeleton';
import { Link } from 'react-router-dom';
import LocationEnquiry from './Enquiries/LocationEnquiry';
import ModalContainer from '../components/ModalContainer';

export class TotePutAway extends Component {
    static displayName = TotePutAway.name;

    constructor(props) {
        super(props);
        this.reset();
    }
    reset(setState) {
        this.state = {
            alertMessage: "",
            data: [],
            toteText: "",
            locationText: "",
            confirmingLocation: "",
            labelText: MyGlobal.strings.scanCarton,
            toteReadOnly: false,
            locationStatus: "",
            charge: "",
            locationValidated: false,
            chargesToBeConfirmed: [
                "STANDARD PALLET",
                "TWO PALLET",
                "THREE PALLET",
                "FOUR PALLET",
                "SIX PALLET",
                "EIGHT PALLET"],
            locationData: "",
            clientName: "",
            Namecode: "",
            displayLocationOccupiedWarning: false,
            showModal: false,
            modalContent: null
        };
        if (setState) {
            this.setState(this.state);
            this.txtTote.focus();
            this.populateData();

        }
    }
    componentDidMount() {
        this.populateData();
        this.setState({
            clientName: "",
            chargesToBeConfirmed: [
                "STANDARD PALLET",
                "TWO PALLET",
                "THREE PALLET",
                "FOUR PALLET",
                "SIX PALLET",
                "EIGHT PALLET"]
        });
    }

    async populateData() {

        var warehouseID = MyGlobal.warehouse;
        var url = `api/Tote/GetTotesToPutAway?warehouseID=${warehouseID}`;
        const response = await fetch(url, {

        });
        const data = await response.json();
        this.setState({ data: data, loading: false });
    }

    txtKeyPressed(e) {

        let $target = $(e.currentTarget);
        let txtboxName = $target.attr('name');
        this.setState({ alertMessage: "" });

        switch (txtboxName) {
            case "txtTote":
                if (e?.which == 13) {
                    this.handleToteLocation($target);
                }
                break;
            case "txtLocation":
                this.setState({ locationValidated: false, locationStatus: "", charge: "" });
                if (e?.which == 13) {
                    this.handleTextLocation($target);
                }
                break;
            case "txtPlacementCheckLocation":
                if (e?.which == 13) {
                    this.handlePlacementCheckLocation($target);
                }

        }
    }

    async handleToteLocation() {
        let newState = { ...this.state };
        let selectedToteText = newState.toteText.trim().toUpperCase();
        let tote = newState.data.find(row => row.Tote.trim().toUpperCase() == selectedToteText);

        if (tote) {

            let toteCount = newState.data.filter(row => row.Tote.trim().toUpperCase() == selectedToteText).length;
            if (toteCount > 1) {

                newState.alertMessage = "Duplicate SSCC found, tote cannot be selected until  this is is resolved.";
                MySound.play(MySound.Sound.stop);
            }
            else {
                newState.clientName = tote.NAME;
                if (tote.approved) {

                    newState.alertMessage = MyGlobal.strings.needApproval;
                    MySound.play(MySound.Sound.stop);
                } else {

                    newState.alertMessage = MyGlobal.strings.scanLocation;
                    newState.toteReadOnly = true;
                    $("#txtLocation").focus();
                }
            }

        } else {
            newState.alertMessage = MyGlobal.strings.invalidToteId;
            MySound.play(MySound.Sound.stop);
        }
        this.setState(newState);
    }

    async handleTextLocation() {
        let newState = { ...this.state };

        if (newState.locationText == "") {
            newState.alertMessage = MyGlobal.strings.invalidLocation;
            MySound.play(MySound.Sound.stop);
            return;
        }
        else {
            await this.getLocationStatus(newState.locationText);
            return;
        }


        this.setState(newState);
    }


    async handlePlacementCheckLocation() {

        let newState = { ...this.state };

        if (newState.confirmingLocation.trim().toUpperCase() == newState.locationText.trim().toUpperCase() && newState.locationValidated === true) {
            await this.setMoveToteLocation();
            return;
        } else {
            MySound.play(MySound.Sound.stop);
            newState.confirmingLocation = "";
            newState.alertMessage = MyGlobal.strings.locationDontMatch;
        }

        this.setState(newState);
    }


    async getLocationStatus(locationBarcode) {
        this.setState({ alertMessage: "", loading: true });
        var warehouseID = MyGlobal.warehouse;
        var url = `api/Tote/GetLocationStatusByBarcode?warehouseID=${warehouseID}&barcode=${locationBarcode}`;
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            const error = await response.json(); // or response.json()
            this.setState({ alertMessage: error[0].message, loading: false });
            return;
        }

        const data = await response.json();

        //Read the response and normal, continue , if invalid return an error
        if (data != null) {
            if (data.length > 0) {
                let status = "";
                let charge = "";
                for (var value of data) {
                    status = value.Status;
                    charge = value.Charge;
                }

                this.state.locationData = data;
                this.state.locationStatus = status;
                this.state.charge = charge;

                if (status === "VOID") {

                    MySound.play(MySound.Sound.stop);
                    this.setState({ alertMessage: MyGlobal.strings.unableToUseLocation, loading: false });
                    return;
                }
                else {

                    let encodedName = encodeURIComponent(this.state.clientName);

                    fetch(`api/Location/GetClientNamecode?accountName=${encodedName}`)
                        .then(async response => {

                            // check for error response
                            if (!response.ok) {
                                const errorText = await response.text();
                                console.error(errorText);
                                this.setState({ alertMessage: "Failed to load Client Namecode!!", loading: false });
                                return;
                            }
                            else {
                                const isJson = response.headers.get('content-type')?.includes('application/json');
                                const apiResponse = isJson ? await response.json() : null;
                                if (apiResponse) {

                                    if (apiResponse.success) {

                                        if (apiResponse.data) {

                                            this.state.Namecode = apiResponse.data.namecode;


                                            fetch(`api/Location/IsLocationTypeExclusion?locationId=${this.state.locationData[0].LOC_ID}`)
                                                .then(async response => {

                                                    // check for error response
                                                    if (!response.ok) {
                                                        const errorText = await response.text();
                                                        this.setState({ alertMessage: "Failed to check Location Type!!", loading: false });
                                                        return;
                                                    }
                                                    else {
                                                        const isJson = response.headers.get('content-type')?.includes('application/json');
                                                        const apiResponse = isJson ? await response.json() : null;
                                                        if (apiResponse) {

                                                            if (apiResponse.success) {
                                                                if (apiResponse.data === true) {
                                                                    this.setState({ loading: false });
                                                                    this.confirmScannedLocation();
                                                                    return;
                                                                }
                                                                else {
                                                                    var locationBarcode = this.state.locationText.trim().toUpperCase();
                                                                    var namecode = this.state.Namecode;
                                                                    let tote = this.state.toteText.trim().toUpperCase();

                                                                    const validateToteRequest = {
                                                                        method: 'POST',
                                                                        headers: { 'Content-Type': 'application/json' },
                                                                        body: JSON.stringify({
                                                                            Namecode: namecode,
                                                                            WarehouseID: warehouseID,
                                                                            CartonId: tote,
                                                                            LocationBarcode: locationBarcode
                                                                        })
                                                                    };
                                                                    fetch(`api/Tote/ValidateClientSwitches`, validateToteRequest)
                                                                        .then(async response => {

                                                                            this.setState({ loading: false });
                                                                            // check for error response
                                                                            if (!response.ok) {
                                                                                const errorText = await response.text();
                                                                                this.setState({ alertMessage: "Failed to validate Client Switches!!" + errorText, loading: false });
                                                                                return;
                                                                            }
                                                                            else {
                                                                                const isJson = response.headers.get('content-type')?.includes('application/json');
                                                                                const apiResponse = isJson ? await response.json() : null;
                                                                                if (apiResponse) {

                                                                                    if (apiResponse.success) {

                                                                                        if (apiResponse.message === "Display SW19 Warning") {

                                                                                            MySound.play(MySound.Sound.warning);
                                                                                            this.setState({ displayLocationOccupiedWarning: true });
                                                                                        }
                                                                                        else {
                                                                                            this.confirmScannedLocation();
                                                                                            return;
                                                                                        }

                                                                                    }
                                                                                    else {
                                                                                        MySound.play(MySound.Sound.stop);
                                                                                        this.setState({ alertMessage: apiResponse.errorMessage, loading: false });
                                                                                    }


                                                                                }
                                                                                else {
                                                                                    this.setState({ alertMessage: "Failed to validate Client Switches!!", loading: false });
                                                                                }
                                                                            }
                                                                        })
                                                                        .catch(error => {
                                                                            this.setState({ alertMessage: error, loading: false });
                                                                        });
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ alertMessage: "Failed to check Location Type!!" + apiResponse.errorMessage, loading: false });
                                                            }
                                                        }
                                                        else {
                                                            this.setState({ alertMessage: "Failed to check Location Type!!", loading: false });
                                                        }
                                                    }
                                                })
                                                .catch(error => {
                                                    this.setState({ alertMessage: error, loading: false });
                                                });


                                        }
                                        else {
                                            this.setState({ alertMessage: "Failed to load Client Namecode!!", loading: false });
                                        }

                                    }
                                    else {
                                        this.setState({ alertMessage: "Failed to load Client Namecode!!", loading: false });
                                    }
                                }
                                else {
                                    this.setState({ alertMessage: "Failed to load Client Namecode!!", loading: false });
                                }
                            }
                        })
                        .catch(error => {
                            this.setState({ alertMessage: error, loading: false });
                        });
                }
            }
            else {
                MySound.play(MySound.Sound.stop);
                this.setState({ alertMessage: "Location not found", loading: false });
            }
        }
        else {

            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Location not found", loading: false });
        }

    }

    async confirmScannedLocation() {
        let newState = { ...this.state };
        newState.locationValidated = true;
        newState.displayLocationOccupiedWarning = false;
        if (newState.confirmingLocation == "") {

            newState.alertMessage = MyGlobal.strings.scanToConfirm;
            $("#txtPlacementCheckLocation").focus();
            MySound.play(MySound.Sound.next);
        }
        this.setState(newState);
    }
    async setMoveToteLocation() {
        let tote = this.state.toteText.trim().toUpperCase();
        let location = this.state.locationText.trim().toUpperCase();
        let userID = MyGlobal.user;
        var warehouseID = MyGlobal.warehouse;
        var url = `api/Tote/SetMoveToteLocationByBarcode?tote=${tote}&location=${location}&userID=${userID}&warehouseID=${warehouseID}`;

        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data && data.length > 0 && data[0].updates > 0) {

            const matchingChargeToBeConfirmed = this.state.chargesToBeConfirmed.find((element) => {
                return element === this.state.charge;
            });
            if (matchingChargeToBeConfirmed) {

                fetch(`api/Location/GetClientOption?namecode=${this.state.Namecode}&warehouseId=${warehouseID}&option=90`)
                    .then(async response => {
                        this.setState({ loading: false });
                        // check for error response
                        if (!response.ok) {
                            const errorText = await response.text();
                            console.error(errorText);
                            this.setState({ alertMessage: "Failed to load ClientOptions!!", loading: false });
                            return;
                        }
                        else {
                            const isJson = response.headers.get('content-type')?.includes('application/json');
                            const apiResponse = isJson ? await response.json() : null;
                            if (apiResponse) {

                                if (apiResponse.success) {

                                    if (apiResponse.data.value == "Y") {
                                        //Load prompt
                                        this.setState({ displayConfirmChargePrompt: true });
                                    }
                                    else {
                                        MySound.play(MySound.Sound.next);
                                        this.reset(true);
                                        return;
                                    }

                                }
                                else {
                                    this.setState({ alertMessage: "Failed to load ClientOptions!!", loading: false });
                                }
                            }
                            else {
                                this.setState({ alertMessage: "Failed to load ClientOptions!!", loading: false });
                            }
                        }
                    })
                    .catch(error => {
                        this.setState({ alertMessage: error, loading: false });
                    });


            }
            else {
                MySound.play(MySound.Sound.next);
                this.reset(true);
            }
        }
        else {
            this.setState({ alertMessage: "Putaway Update Failed Retry?", loading: false });
            MySound.play(MySound.Sound.stop);
        }
    }

    confirmLocationCloseEvent() {

        this.setState({ displayConfirmChargePrompt: false });
        MySound.play(MySound.Sound.next);
        this.reset(true);
    }

    clearLocation() {
        this.setState({ displayLocationOccupiedWarning: false, locationText: "" });
    }

    renderTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Tote</th>
                        <th>Customer</th>
                        <th>Ref</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) =>
                        <tr key={`${row.Tote}-${index}`}
                            onClick={(e, key) => {
                                $(e.currentTarget).closest("table").find("tr").removeClass("selected");
                                $(e.currentTarget).addClass("selected");
                                this.state.toteText = row.Tote.toUpperCase();

                                let $target = $('#txtTote');
                                this.setState({ locationText: "", confirmingLocation: "" });
                                this.handleToteLocation($target);
                            }}>
                            <td>{row.Tote}</td>
                            <td>{row.NAME}</td>
                            <td>{row.ClientRef}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    openModal = (content) => {
        this.setState({ modalContent: content, showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false, modalContent: null });
    };

    render() {

        let progress = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">

            {alertMessage.split('\r\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))}
        </MyAlert> : "";

        let locationStatusDisplay = this.state.locationStatus;
        locationStatusDisplay = locationStatusDisplay != "" ? <span className="px-2"><b> Status : </b> {this.state.locationStatus} , <b>Charge</b> : {this.state.charge} </span> : "";

        let displayPrompt = this.state.displayConfirmChargePrompt;
        displayPrompt = displayPrompt === true ? <ConfirmLocationChargeSkeleton show={this.state.displayConfirmChargePrompt} locationData={this.state.locationData} onClickClose={() => { this.confirmLocationCloseEvent(); }}  ></ConfirmLocationChargeSkeleton> : "";

        let contents = this.renderTable(this.state.data);

        return (
            <div>
                <MyHeading>{this.state.labelText}</MyHeading>
                <br />
                {progress}
                {alertMessage}
                <div className="form-group">
                    <label htmlFor="txtTote">Tote</label>
                    <input
                        type="text"
                        className="form-control"
                        name="txtTote"
                        id="txtTote"
                        value={this.state.toteText}
                        onKeyPress={(e) => { this.txtKeyPressed(e); }}
                        onChange={(e) => {
                            this.setState({ alertMessage: "", toteText: e.target.value.toUpperCase() });
                        }}
                        autoFocus
                        ref={(input) => { this.txtTote = input; }}
                        readOnly={this.state.toteReadOnly}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="txtLocation">Location </label>
                    {locationStatusDisplay}
                    <input
                        type="text"
                        className="form-control"
                        name="txtLocation"
                        id="txtLocation"
                        value={this.state.locationText}
                        onKeyPress={(e) => { this.txtKeyPressed(e); }}
                        onChange={(e) => {
                            this.setState({ locationText: e.target.value, alertMessage: "", locationValidated: false, charge: "", locationStatus: "" });
                        }}
                        readOnly={!this.state.toteReadOnly}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="txtPlacementCheckLocation">Placement Check Location</label>
                    <input
                        type="text"
                        className="form-control"
                        name="txtPlacementCheckLocation"
                        id="txtPlacementCheckLocation"
                        value={this.state.confirmingLocation}
                        onKeyPress={(e) => { this.txtKeyPressed(e); }}
                        onChange={(e) => {
                            this.setState({ alertMessage: "", confirmingLocation: e.target.value });
                        }}
                        readOnly={!this.state.locationValidated}
                    />
                </div>
                <div className="tableHolder hm-40vh mb-3">
                    {contents}
                </div>
                <div className="container">
                    <div className="row form-group">
                        <LinkButton className="btn btn-success col-12 mb-2" to="ToteApproval" >Approve</LinkButton>
                        <button className="btn btn-success col-12 mb-2" onClick={() => { this.reset(true); }}>Refresh</button>
                        <Link className="btn btn-success col-12 mb-2" to="#" onClick={() => this.openModal(<LocationEnquiry />)}>Location Enquiry</Link>
                    </div>
                </div>

                {displayPrompt}


                <Modal show={this.state.displayLocationOccupiedWarning} backdrop="static" centered>
                    <Modal.Header>
                        <Modal.Title>Warning! Inventory exists in this location. Are you sure you want to mix inventory in this location?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="">
                            <div className="container">
                                <div className="row form-group">
                                    <button type="button" className="btn btn-success col-12 mb-2" disabled={this.state.loading} onClick={() => { this.confirmScannedLocation() }}>Proceed</button>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row form-group">
                                    <button type="button" className="btn btn-danger col-12 mb-2" disabled={this.state.loading} onClick={() => this.clearLocation()} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <ModalContainer show={this.state.showModal} onHide={this.closeModal} content={this.state.modalContent} width="800px" height="500px" />
            </div>
        );
    }


}
